<template>
  <div class="content">
    <div class="col-md-8 flex-container-top" style="display: flex; align-items: center; justify-content: center; gap: 10px; margin: 0 auto;">
      <h2 class="text-center" style="margin: 0;">Support V2 (Live Chat)</h2>
      <span v-if="totalUnreadCount > 0" class="total-unread-badge">
        {{ totalUnreadCount }} unread
      </span>
    </div>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Live Chat Tickets</h4>
          <div>
            <div class="mb-3 d-flex justify-content-center">
              <el-radio-group v-model="currentStatus" @change="fetchTickets" size="small">
                <el-radio-button label="open">Open Tickets</el-radio-button>
                <el-radio-button label="closed">Closed Tickets</el-radio-button>
              </el-radio-group>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData" class="small">
              <el-table-column
                :min-width="200"
                align="left"
                label="User Details"
              >
                <div slot-scope="props">
                  <div style="display: flex; align-items: center;">
                    <div>
                      <div style="display: flex; align-items: center; gap: 6px;">
                        <span>{{ props.row.userId ? props.row.userId.first_name + ' ' + props.row.userId.last_name : 'Unknown' }}</span>
                        <span v-if="props.row.unreadCount > 0" class="unread-badge">
                          {{ props.row.unreadCount }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="250"
                align="left"
                label="Phone Number"
              >
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.userId && props.row.userId.phone_number ? props.row.userId.phone_number : 'N/A' }}</div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Last Message">
                <div slot-scope="props">
                  <div>
                    <div v-if="props.row.lastMessage">{{ props.row.lastMessage.content.substring(0, 50) }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Date">
                <div slot-scope="props">
                  <div>
                    <div>{{ formatDate(props.row.lastActivity) }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column
                :min-width="120"
                header-align="right"
                align="right"
                label="Control"
              >
                <div slot-scope="props" class="text-right table-actions">
                  <base-button
                    @click="editClickhandler(props.row)"
                    class="btn btn-sm btn-primary"
                    title="View"
                  >
                    View
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
    
    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, RadioGroup, RadioButton } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import moment from "moment";
import { io } from "socket.io-client";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
    totalUnreadCount() {
      return this.tableData.reduce((sum, item) => sum + (item.unreadCount || 0), 0);
    },
  },
  data() {
    return {
      loading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentStatus: 'open',
      socket: null,
      socketConnected: false,
    };
  },
  async mounted() {
    await this.fetchTickets();
    this.initSocket();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  },
  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = this.fuseSearch.search(this.searchQuery);
        result = result.map((a) => a.item);
      }
      this.searchedData = result;
    },
  },
  methods: {
    async fetchTickets() {
      this.loading = true;
      if (this.socket && this.socketConnected) {
        this.socket.emit('support_history', { status: this.currentStatus });
        this.loading = false;
        return;
      }
      try {
        let test = await this.$apiService.getCall(`support-v2/admin/tickets?status=${this.currentStatus}`);
        
        let fetchedData = test.apidata.Data;
        if (fetchedData && fetchedData.data) {
          this.tableData = fetchedData.data;
        } else {
          this.tableData = fetchedData || [];
        }
        this.rebuildFuseSearch();
      } catch (e) {
        console.error("Failed to fetch tickets", e);
      }
      this.loading = false;
    },

    editClickhandler(userInformation) {
      this.$router.push("/support_v2/edit?id=" + userInformation._id);
    },

    formatDate(created_at) {
      return moment(created_at).format("DD-MM-YYYY hh:mm a");
    },

    rebuildFuseSearch() {
      const searchData = this.tableData.map(t => ({
         ...t,
         name: t.userId ? t.userId.first_name + ' ' + t.userId.last_name : '',
         phone: t.userId && t.userId.phone_number ? t.userId.phone_number : '',
         message: t.lastMessage ? t.lastMessage.content : ''
      }));
      
      this.fuseSearch = new Fuse(searchData, {
        keys: ["name", "phone", "message"],
        threshold: 0.3,
      });

      // Update searchedData in case query is active
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = this.fuseSearch.search(this.searchQuery);
        result = result.map((a) => a.item);
      }
      this.searchedData = result;
    },

    initSocket() {
      const baseUrl = this.$apiService.apiUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
      const token   = window.localStorage.getItem("token");

      this.socket = io(`${baseUrl}/chat`, {
        auth: { token: `Bearer ${token}` },
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
        forceNew: true
      });

      const onConnect = () => {
        this.socketConnected = true;
        this.socket.emit('support_history', { status: this.currentStatus });
      };

      this.socket.on('connect', onConnect);
      if (this.socket.connected) {
        onConnect();
      }

      this.socket.on('disconnect', () => { this.socketConnected = false; });
      this.socket.on('connect_error', () => { this.socketConnected = false; });

      this.socket.on('support_history', (payload) => {
        if (payload.action === 'update') {
          const updatedChat = payload.chat;
          const matchesStatus = this.currentStatus === 'open' ? updatedChat.isActive !== false : updatedChat.isActive === false;
          
          const index = this.tableData.findIndex(item => item._id === updatedChat._id);
          if (index !== -1) {
            if (matchesStatus) {
              this.$set(this.tableData, index, updatedChat);
            } else {
              this.tableData.splice(index, 1);
            }
          } else if (matchesStatus) {
            this.tableData.unshift(updatedChat);
          }
          
          this.tableData.sort((a, b) => new Date(b.lastActivity) - new Date(a.lastActivity));
          this.rebuildFuseSearch();
        } else {
          if (payload.status === this.currentStatus || !payload.status) {
            this.tableData = payload.data || [];
            this.rebuildFuseSearch();
          }
        }
      });
    },
  },
};
</script>

<style>
.unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fd5d93;
  color: #ffffff !important;
  padding: 0 6px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  margin-left: 10px;
  text-align: center;
  box-shadow: 0 2px 5px rgba(253, 93, 147, 0.45);
}
.total-unread-badge {
  display: inline-block;
  background: rgba(253, 93, 147, 0.25);
  color: #fd5d93;
  border: 1px solid rgba(253, 93, 147, 0.4);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(253, 93, 147, 0.15);
}
</style>
